import React, { useState } from 'react';

// COMPONENT
import SvgMask from '../_Helpers/SvgMask';

// TYPE
export type AnswerState = 'correct' | 'incorrect';

interface MarkingButtonProps {
	state?: AnswerState;
	className?: string;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const MarkingButton: React.FC<MarkingButtonProps> = ({ state = 'default', className = '', onClick }) => {
	const [isActive, setIsActive] = useState(false);

	return (
		<button
			className={`assessment-marking-button ${state} ${isActive ? 'active' : ''}`}
			onClick={onClick}
			onClickCapture={() => {
				setIsActive(true);

				setTimeout(() => {
					setIsActive(false);
				}, 300);
			}}
		>
			{state === 'correct' ? (
				<SvgMask className="icon" path={'/svg/check-solid.svg'} width={32} height={32} />
			) : (
				<SvgMask className="icon" path={'/svg/cross-solid.svg'} width={32} height={32} />
			)}
		</button>
	);
};

export default MarkingButton;
